import { createReducer, on } from '@ngrx/store';
import { ITrainingState } from '../models/training.model';
import {
  clearSectionData,
  clearStageData,
  clearTrainingData,
  getCurrentSectionInfo,
  getCurrentSectionInfoFailed,
  getCurrentSectionInfoSuccess,
  getCurrentStage,
  getCurrentStageFailed,
  getCurrentStageSuccess,
  getSearchResultsFiles,
  getSearchResultsFilesFailed,
  getSearchResultsFilesSuccess,
  getSectionsList,
  getSectionsListFailed,
  getSectionsListSuccess,
} from '../actions/training.action';
import { SectionsListModes } from '../../../shared/enums';

const initialState: ITrainingState = {
  sectionsList: [],
  section: null,
  stage: null,
  trainingFilesList: [],
  currentMode: SectionsListModes.listViewMode,
  allDataFetched: false,
  isLoading: false,
  error: null,
};

export const trainingReducer = createReducer(
  initialState,
  on(
    getSectionsList,
    getCurrentSectionInfo,
    getSearchResultsFiles,
    getCurrentStage,
    (state: ITrainingState): ITrainingState => ({
      ...state,
      allDataFetched: false,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    getSectionsListSuccess,
    (state: ITrainingState, action): ITrainingState => ({
      ...state,
      sectionsList: action.sectionsList,
      currentMode: SectionsListModes.listViewMode,
      allDataFetched: true,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    getSearchResultsFilesSuccess,
    (state: ITrainingState, action): ITrainingState => ({
      ...state,
      trainingFilesList:
        action.resetData || !state.trainingFilesList
          ? action.trainingFilesList
          : [...state.trainingFilesList, ...action.trainingFilesList],
      currentMode: SectionsListModes.searchMode,
      allDataFetched: action.trainingFilesList.length < 20,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    getCurrentSectionInfoSuccess,
    (state: ITrainingState, action): ITrainingState => ({
      ...state,
      section: action.section,
      currentMode: SectionsListModes.listViewMode,
      allDataFetched: true,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    getCurrentStageSuccess,
    (state: ITrainingState, action): ITrainingState => ({
      ...state,
      stage: action.stage,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    getSectionsListFailed,
    getCurrentSectionInfoFailed,
    getCurrentStageFailed,
    getSearchResultsFilesFailed,
    (state: ITrainingState, action): ITrainingState => ({
      ...state,
      isLoading: false,
      error: action.error,
    }),
  ),
  on(
    clearTrainingData,
    (): ITrainingState => ({
      ...initialState,
    }),
  ),
  on(
    clearStageData,
    (state): ITrainingState => ({
      ...state,
      stage: null,
      isLoading: false,
      currentMode: SectionsListModes.listViewMode,
    }),
  ),
  on(
    clearSectionData,
    (state): ITrainingState => ({
      ...state,
      section: null,
      isLoading: false,
      currentMode: SectionsListModes.listViewMode,
    }),
  ),
);
